import React from "react";
import { useApp } from "../../context/AppContext";
import { FONT_SIZES, FONT_FAMILY } from "../../constants/appConfig";

export const ActionButton = ({ label, icon: Icon, onClick, variant = "primary", small = false, disabled = false }) => {
  const { palette } = useApp();
  const styles = {
    primary: { bg: palette.accent1, color: "#fff", border: "none", hover: palette.accent2 },
    secondary: { bg: "transparent", color: palette.text1, border: `1px solid ${palette.inputBorder}`, hover: `${palette.accent1}10` },
    ghost: { bg: "rgba(255,255,255,0.15)", color: "#fff", border: "1px solid rgba(255,255,255,0.3)", hover: "rgba(255,255,255,0.25)" },
    danger: { bg: "#fee2e2", color: "#dc2626", border: "1px solid #fecaca", hover: "#fecaca" }
  };
  const s = styles[variant] || styles.primary;

  return (
    <button onClick={onClick} disabled={disabled} style={{
      display: "inline-flex", alignItems: "center", gap: 6,
      padding: small ? "6px 10px" : "8px 16px", borderRadius: 8,
      fontSize: small ? FONT_SIZES.xs : FONT_SIZES.sm,
      fontWeight: 600, fontFamily: FONT_FAMILY,
      cursor: disabled ? "not-allowed" : "pointer",
      background: s.bg, color: s.color, border: s.border,
      opacity: disabled ? 0.5 : 1, transition: "all 0.2s"
    }}
      onMouseEnter={e => { if (!disabled) e.currentTarget.style.background = s.hover; }}
      onMouseLeave={e => { if (!disabled) e.currentTarget.style.background = s.bg; }}
    >{Icon && <Icon size={small ? 13 : 15} />}{label}</button>
  );
};
